// i18n area 'common' — locale pt-PT (pt-PT, task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.pt-PT.meta.json.
// DA RIVEDERE DA MADRELINGUA (F7 rinviata): rinomina F1 arquivo→«cópia de configuração» (#247).
import type { enUS } from './common'

export const ptPT: typeof enUS = {
  nav: {
    home: 'Home',
    vms: 'Máquinas virtuais',
    templates: 'Templates',
    importVms: 'Importar VMs',
    containers: 'Containers',
    containersApps: 'Apps',
    containersPods: 'Pods',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'Imagens OCI',
    containersOciRegistries: 'Registries OCI',
    containersCtTemplates: 'Templates CT',
    networkServices: 'Serviços de rede',
    firewall: 'Firewall',
    checkpoints: 'Checkpoints',
    backup: 'Backup',
    monitoring: 'Monitorização',
    cluster: 'Cluster',
    clusterSettings: 'Definições globais',
    clusterNodes: 'Nós',
    clusterDevices: 'Recursos USB e PCIe',
    clusterFederation: 'Federação',
    network: 'Rede',
    overlayNetworks: 'Redes overlay',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Dados',
    storages: 'Storage',
    hci: 'Hiperconvergência',
    ceph: 'Ceph',
    system: 'Sistema',
    tasks: 'Tasks',
    events: 'Eventos',
    audit: 'Auditoria',
    diagnostics: 'Diagnóstico',
    notifications: 'Notificações',
    proximity: 'TVirt Proximity',
    users: 'Utilizadores e grupos',
    groups: 'Grupos',
    mfa: 'MFA',
    realms: 'Realms e SSO',
    rbac: 'Funções e permissões',
    credentials: 'Credenciais',
    scopes: 'Scopes',
    tags: 'Tags',
    explorer: 'Explorar',
    licensing: 'Licença',
    information: 'Informações'
  },
  mode: {
    light: 'Claro',
    dark: 'Escuro',
    system: 'Sistema',
    tooltip: 'Tema'
  },
  language: {
    tooltip: 'Idioma'
  },
  langRegion: {
    europe: 'Europa',
    northAmerica: 'América do Norte',
    southAmerica: 'América do Sul',
    asia: 'Ásia'
  },
  notFound: {
    title: 'Página não encontrada',
    body: 'Este endereço não corresponde a nenhuma página do TVirt — pode ter mudado com uma atualização, ou o link é antigo.',
    backHome: 'Voltar à Home'
  },
  scopeBrowser: {
    title: 'Scopes',
    all: 'Todo o cluster',
    noChildren: 'Nenhum sub-scope aqui',
    recursive: 'Incluir descendentes',
    collapse: 'Recolher o painel de scopes',
    openPicker: 'Explorar os scopes',
    up: 'Subir um nível',
    countTooltip: '{direct} neste scope · {total} com os descendentes'
  },
  search: {
    tooltip: 'Pesquisar (⌘K)',
    placeholder: 'Pesquisar VMs, redes, storage…',
    empty: 'Nenhum resultado',
    groups: {
      recent: 'Recentes',
      shortcuts: 'Atalhos',
      actions: 'Ações',
      goTo: 'Ir para'
    },
    kind: {
      catalog: 'Catálogo',
      scope: 'Scope',
      node: 'Nó'
    },
    footer: {
      navigate: 'navegar',
      open: 'abrir',
      close: 'fechar'
    },
    actions: {
      createVm: 'Criar VM…',
      uploadIso: 'Carregar ISO…',
      clusterSettings: 'Definições do cluster',
      consoleOf: 'Ir para a consola de {name}'
    }
  },
  stub: {
    containersSummary: 'Aplicações e containers de sistema (CT), com as suas imagens OCI, os registries e os templates — geridos ao lado das suas VMs.',
    sectionSummary_vms: 'Máquinas virtuais e os seus templates — ciclo de vida, snapshots, migração e consolas.',
    sectionSummary_storages: 'Os storages onde vivem discos, imagens e metadados das VMs.',
    sectionSummary_catalogs: 'A casa dos artefactos de ficheiro do cluster: imagens ISO, templates CT e VM e arquivos OCI, organizados em catálogos.',
    sectionSummary_overlay: 'Redes overlay VXLAN entre os nós do cluster.',
    sectionSummary_fabric: 'O inventário da rede física — switches, portas, LAGGs e redes lógicas.',
    sectionSummary_ipam: 'O endereçamento derivado das redes fabric e overlay: quem detém cada endereço.',
    sectionSummary_services: 'Servidores DHCP e DNS derivados do registo de rede.',
    sectionSummary_ceph: 'Clusters Ceph geridos nos nós TVirt.',
    sectionSummary_hci: 'As tecnologias de storage hiperconvergentes nos nós TVirt.',
    sectionSummary_cluster: 'Nós, pertença e definições de cluster.',
    containers: 'Os containers de sistema estão no roadmap — esta secção irá alojá-los.',
    containersApps: 'As aplicações containerizadas estão no roadmap — esta área irá alojá-las.',
    containersPods: 'Os pods agrupam contentores que partilham rede e volumes — as instâncias são as apps.',
    containersCt: 'Os containers de sistema (CT) estão no roadmap — esta área irá alojá-los.',
    multiscsi: 'O TVStor MultiSCSI está no roadmap — esta área irá alojá-lo.',
    clusterFederation: 'A federação entre clusters TVirt está no roadmap — esta área irá alojá-la.',
    containersOciImages: 'As imagens OCI estão no roadmap — esta área irá alojá-las.',
    containersOciRegistries: 'Os registries OCI estão no roadmap — esta área irá alojá-los.',
    containersCtTemplates: 'Os templates CT estão no roadmap — esta área irá alojá-los.',
    importVms: 'Os importers ESXi e Proxmox chegarão aqui: conversão dos guests e migração em massa para dentro do TVirt.',
    backup: 'O backup integrado chega com a 6.2: repositórios content-addressed deduplicados, incrementais CBT, janelas de imutabilidade e replicação repo-to-repo.',
    monitoring: 'Os dashboards de contenção cluster-wide (cpu.ready, pressão PSI, alertas integrados) estão a chegar — hoje as mesmas métricas vivem nos detalhes de cada VM.'
  },
  home: {
    welcome: 'Iniciou sessão com o utilizador: {name}',
    subtitle: 'Aqui está o seu cluster TVirt num relance.',
    loadError: 'Impossível carregar a vista geral — o backend TVirt está acessível?',
    health: {
      ok: 'Tudo em ordem',
      warning: 'Atenção',
      critical: 'Problemas críticos'
    },
    reason: {
      'node-down': '{subject} está desligado',
      'node-stale': '{subject} não dá sinal há algum tempo',
      'node-maintenance': '{subject} em manutenção',
      'tasks-failed': {
        one: '{n} task falhada nas últimas 24h',
        many: '{n} tasks falhadas nas últimas 24h',
        other: '{n} tasks falhadas nas últimas 24h'
      },
      'storage-degraded': 'storage {subject} degradado',
      'storage-error': 'storage {subject} em erro',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'store do cluster inacessível',
      'license-absent': 'sem licença — as novas VMs não podem arrancar',
      'license-expired': 'licença expirada — as novas VMs não podem arrancar',
      'license-exceeded': 'limite de licença excedido — as novas VMs não podem arrancar',
      'failover-reserve-eroded': 'reserva de failover quase consumida',
      'failover-reserve-exhausted': 'reserva de failover esgotada — as novas VMs não podem arrancar',

      'oci-cache-nearly-full': 'cache OCI quase cheia em {subject} — os digest despejam-se à mão',
      'oci-cache-full': 'cache OCI cheia em {subject} — nenhum pull terá êxito até despejar digest',
      'config-replica-empty': 'réplica de configuração VAZIA em {subject} — o nó não tem configuração do cluster até uma replicação ter êxito',
      'config-replica-stalled': 'replicação de configuração parada em {subject} — a cópia local está atrasada face à configuração do cluster'
    },
    staleChip: 'Dados desatualizados',
    staleAsOf: 'última réplica {time}',
    zone: {
      nodes: 'Nós',
      failoverReserve: 'Reserva de failover',
      capacity: 'Capacidade',
      workload: 'Carga de trabalho',
      protection: 'Proteção',
      activity: 'Atividade recente'
    },
    reserve: {
      state: {
        ok: 'Reserva intacta',
        eroded: 'Reserva quase consumida',
        exhausted: 'Reserva esgotada',
        unknown: 'Reserva desconhecida'
      },
      tolerate: {
        one: 'tolera a perda de {n} nó',
        many: 'tolera a perda de {n} nós',
        other: 'tolera a perda de {n} nós'
      },
      usedOf: '{used} / {allowed} GiB em uso',
      keepFree: '{n} GiB mantidos livres para o failover',
      expendable: 'dos quais {n} sacrificáveis em serviço',
      headroom: 'ainda se podem arrancar {n} GiB',
      short: 'faltam {n} GiB à reserva — as novas VMs não podem arrancar',
      hp: {
        usedOf: 'Páginas de {size} — em uso: {used} / {allowed}',
        keepFree: 'mantidas livres para o failover: {keep}',
        headroom: 'ainda arrancáveis: {n}',
        short: 'em falta na reserva: {n} — as novas VMs com páginas enormes não podem arrancar'
      },
      worstCase: 'pior caso: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Nenhum nó declarou ainda a sua memória — a reserva não é calculável e nenhum arranque é recusado.',
      reason: {
        attestedDown: 'atestado desligado',
        maintenance: 'em manutenção',
        unreachable: 'inacessível',
        capacityUnknown: 'memória não declarada'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} cores / {threads} threads',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} VM ativa',
        many: '{n} VMs ativas',
        other: '{n} VMs ativas'
      },
      activeVmsUnknown: 'VMs ativas desconhecidas',
      lastSeen: 'visto {time}',
      neverSeen: 'nunca visto',
      down: 'Desligado',
      maintenance: 'Manutenção',
      stale: 'Inacessível'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB provisionados',
      reserve: 'reserva {n} GiB',
      unobserved: 'capacidade ainda não observada',
      empty: 'Ainda sem storage'
    },
    workload: {
      vms: 'Máquinas virtuais',
      apps: 'Apps',
      services: 'Serviços de rede',
      empty: 'Ainda nenhum',
      phasesUnknown: 'repartição por fase indisponível'
    },
    protection: {
      none: 'Nenhum destino de backup configurado — proteja a sua configuração.',
      configure: 'Configurar os checkpoints',
      noRuns: 'Nenhum checkpoint foi criado ainda.',
      last: 'Último checkpoint',
      onTarget: 'em {target}',
      viewAll: 'Checkpoints'
    },
    activity: {
      empty: 'Nenhuma atividade recente',
      failed24: {
        one: '{n} falhada em 24h',
        many: '{n} falhadas em 24h',
        other: '{n} falhadas em 24h'
      },
      viewAll: 'Ver todas as tasks'
    }
  },
  notes: {
    title: 'Notas',
    tabEdit: 'Editar',
    tabPreview: 'Pré-visualização',
    placeholder: 'Notas livres do operador — o Markdown é renderizado na pré-visualização',
    empty: 'Nenhuma nota',
    tooLarge: 'As notas excedem o limite de 64 KiB',
    saveError: 'Não foi possível guardar as notas'
  },
  common: {

    // Round «errori onesti» (2026-08-03): una risposta 200 che questo client
    // non sa leggere NON è una rete giù — accusare il backend manda
    // l'operatore a guardare un servizio che funziona (bug hunt #157, U1).
    contractError: 'A resposta do backend contém um valor que esta interface não conhece: {field}={value} — atualize a interface web para a versão do backend.',
    contractErrorItems: '{count} objetos desta lista não podem ser lidos por esta interface ({field}={value}) e não são exibidos.',
    staleHint: 'O store não está acessível — esta é a réplica de config deste nó; o estado da frota é desconhecido.',
    staleStateAge: 'estado de {time}',
    staleStateNever: 'estado nunca recebido do store: vê apenas as observações deste nó',
    staleStateTooltip: 'O store do cluster não está acessível: o estado observado (fase, nó, agente) vem da réplica de estado deste nó e remonta à última leitura bem-sucedida do store — pode estar desatualizado.',
    noPermission: 'Não tem permissão para esta ação',
    actionStillRunning: 'A ação ainda está em curso — o resultado ainda não é conhecido',
    staleWrite: 'Outra pessoa alterou este objeto enquanto o editava — nada foi escrito. Recarregue e repita a alteração sobre o estado atual.',
    staleReload: 'Recarregar',
    preview: 'Pré-visualização',
    previewTitle: 'Pré-visualização do resultado',
    previewNothingWritten: 'Simulada no servidor — nada foi escrito.',
    previewChanged: 'Em destaque: os valores que mudariam.'
  },
  context: {
    copySelection: 'Copiar texto selecionado'
  },
  crud: {
    create: 'Criar',
    viewDetails: 'Ver detalhes',
    viewOrEdit: 'Ver ou editar',
    selected: 'selecionados',
    viewUsingVms: 'Ver as VMs que usam o recurso',
    clearSelection: 'Limpar',
    deleteSelected: 'Eliminar selecionados',
    bulkConfirmBody: {
      one: 'Eliminar {count} elemento selecionado? Se estiver protegido, será assinalado e mantido.',
      many: 'Eliminar os {count} elementos selecionados? Os protegidos serão assinalados e mantidos.',
      other: 'Eliminar os {count} elementos selecionados? Os protegidos serão assinalados e mantidos.'
    },
    bulkDeleted: 'eliminados',
    bulkRefused: 'recusados',
    fieldId: 'ID',
    createdAt: 'Criado em',
    updatedAt: 'Atualizado em',
    immutableField: 'Fixado na criação — o contract não permite alterá-lo',
    immutableScope: 'O scope é atribuído na criação; alguns recursos movem-se com uma ação dedicada',
    observedField: 'Estado observado — reportado pela plataforma, não editável'
  }
}
